'use client';

import { likeShare, likeSquarePost } from '@/app/actions/share';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useAuth } from '@/providers/auth-provider';
import { HeartIcon } from 'lucide-react';
import React from 'react';

export default function LikeButton({
  token,
  count,
  isLiked,
  shareId,
  postId,
}: {
  token: string;
  count: number;
  isLiked: boolean;
  shareId?: string;
  postId?: string;
}) {
  const { user, triggerLogin } = useAuth();
  const [liked, setLiked] = React.useState(isLiked);
  const [likeCount, setLikeCount] = React.useState(count);

  const clickLike = async () => {
    const nextLiked = !liked;
    setLiked(nextLiked);
    setLikeCount((prev) => (nextLiked ? prev + 1 : prev - 1));
    try {
      if (postId) {
        await likeSquarePost(postId, nextLiked, token);
      } else if (shareId) {
        await likeShare(shareId, nextLiked, token);
      } else {
        throw new Error('Missing like target id');
      }
    } catch (e) {
      console.error(e);
      setLiked(liked);
      setLikeCount((prev) => (nextLiked ? prev - 1 : prev + 1));
    }
  };

  const onLike = () => {
    if (!user && triggerLogin) {
      triggerLogin(() => clickLike());
    } else {
      clickLike();
    }
  };
  return (
    <Button
      size="sm"
      variant="ghost"
      onClick={onLike}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <HeartIcon
        className={cn('w-4 h-4', {
          'fill-primary text-primary': liked,
        })}
      />
      <span className="inline-block tabular-nums">{likeCount}</span>
    </Button>
  );
}
